var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinePatterns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 384,
    viewBox: "0 0 352 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 384.064C1133.16 384.064 775.071 -125.018 626.529 11.8066C560.21 72.8955 606.654 164.147 542.09 227.103C394.145 371.367 237.574 -131.77 70.1508 -10.8561C-21.5535 55.3755 -53.1638 251.864 -53.1638 251.864",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 390.836C1133.16 390.836 775.071 -118.246 626.529 18.579C560.21 79.668 606.654 170.919 542.09 233.875C394.145 378.139 237.574 -124.999 70.1508 -4.08372C-21.5535 62.148 -53.1638 258.637 -53.1638 258.637",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 397.608C1133.16 397.608 775.071 -111.474 626.529 25.351C560.21 86.4401 606.654 177.69 542.09 240.648C394.145 384.911 237.574 -118.227 70.1508 2.6882C-21.5535 68.9201 -53.1638 265.409 -53.1638 265.409",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 404.378C1133.16 404.378 775.071 -104.704 626.529 32.1217C560.21 93.2102 606.654 184.461 542.09 247.418C394.145 391.682 237.574 -111.456 70.1508 9.4589C-21.5535 75.691 -53.1638 272.179 -53.1638 272.179",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 411.151C1133.16 411.151 775.071 -97.9312 626.529 38.8942C560.21 99.9828 606.654 191.234 542.09 254.19C394.145 398.454 237.574 -104.683 70.1508 16.2314C-21.5535 82.4636 -53.1638 278.952 -53.1638 278.952",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 417.923C1133.16 417.923 775.071 -91.159 626.529 45.6664C560.21 106.755 606.654 198.006 542.09 260.963C394.145 405.226 237.574 -97.911 70.1508 23.0036C-21.5535 89.2359 -53.1638 285.724 -53.1638 285.724",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 424.696C1133.16 424.696 775.071 -84.3865 626.529 52.4388C560.21 113.528 606.654 204.779 542.09 267.735C394.145 411.999 237.574 -91.1385 70.1508 29.7761C-21.5535 96.0077 -53.1638 292.496 -53.1638 292.496",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 431.466C1133.16 431.466 775.071 -77.6163 626.529 59.2094C560.21 120.298 606.654 211.549 542.09 274.506C394.145 418.769 237.574 -84.3683 70.1508 36.5463C-21.5535 102.778 -53.1638 299.267 -53.1638 299.267",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 438.238C1133.16 438.238 775.071 -70.8441 626.529 65.981C560.21 127.07 606.654 218.321 542.09 281.277C394.145 425.542 237.574 -77.5961 70.1508 43.3185C-21.5535 109.551 -53.1638 306.038 -53.1638 306.038",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 445.01C1133.16 445.01 775.071 -64.0716 626.529 72.7535C560.21 133.842 606.654 225.093 542.09 288.05C394.145 432.314 237.574 -70.8236 70.1508 50.091C-21.5535 116.323 -53.1638 312.811 -53.1638 312.811",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 451.781C1133.16 451.781 775.071 -57.301 626.529 79.5243C560.21 140.613 606.654 231.864 542.09 294.821C394.145 439.084 237.574 -64.0531 70.1508 56.8615C-21.5535 123.094 -53.1638 319.582 -53.1638 319.582",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 458.553C1133.16 458.553 775.071 -50.529 626.529 86.2965C560.21 147.385 606.654 238.637 542.09 301.593C394.145 445.856 237.574 -57.281 70.1508 63.6338C-21.5535 129.865 -53.1638 326.354 -53.1638 326.354",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 465.326C1133.16 465.326 775.071 -43.7563 626.529 93.0693C560.21 154.158 606.654 245.408 542.09 308.366C394.145 452.629 237.574 -50.5084 70.1508 70.4065C-21.5535 136.638 -53.1638 333.127 -53.1638 333.127",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 472.098C1133.16 472.098 775.071 -36.9847 626.529 99.841C560.21 160.93 606.654 252.18 542.09 315.137C394.145 459.401 237.574 -43.7367 70.1508 77.1783C-21.5535 143.41 -53.1638 339.898 -53.1638 339.898",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 478.869C1133.16 478.869 775.071 -30.2135 626.529 106.612C560.21 167.7 606.654 258.952 542.09 321.908C394.145 466.172 237.574 -36.9656 70.1508 83.9488C-21.5535 150.181 -53.1638 346.669 -53.1638 346.669",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 485.641C1133.16 485.641 775.071 -23.4412 626.529 113.384C560.21 174.473 606.654 265.724 542.09 328.68C394.145 472.944 237.574 -30.1932 70.1508 90.7214C-21.5535 156.954 -53.1638 353.442 -53.1638 353.442",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 492.413C1133.16 492.413 775.071 -16.6691 626.529 120.156C560.21 181.245 606.654 272.496 542.09 335.453C394.145 479.716 237.574 -23.4211 70.1508 97.4936C-21.5535 163.725 -53.1638 360.214 -53.1638 360.214",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 499.186C1133.16 499.186 775.071 -9.89666 626.529 126.929C560.21 188.018 606.654 279.269 542.09 342.225C394.145 486.489 237.574 -16.6487 70.1508 104.266C-21.5535 170.498 -53.1638 366.986 -53.1638 366.986",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 505.957C1133.16 505.957 775.071 -3.12611 626.529 133.7C560.21 194.788 606.654 286.039 542.09 348.996C394.145 493.26 237.574 -9.87809 70.1508 111.037C-21.5535 177.268 -53.1638 373.757 -53.1638 373.757",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 512.728C1133.16 512.728 775.071 3.64613 626.529 140.471C560.21 201.56 606.654 292.811 542.09 355.767C394.145 500.032 237.574 -3.10596 70.1508 117.808C-21.5535 184.041 -53.1638 380.529 -53.1638 380.529",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 519.501C1133.16 519.501 775.071 10.4185 626.529 147.244C560.21 208.332 606.654 299.584 542.09 362.54C394.145 506.804 237.574 3.66644 70.1508 124.581C-21.5535 190.813 -53.1638 387.301 -53.1638 387.301",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 526.271C1133.16 526.271 775.071 17.1891 626.529 154.015C560.21 215.103 606.654 306.354 542.09 369.311C394.145 513.574 237.574 10.4372 70.1508 131.352C-21.5535 197.584 -53.1638 394.072 -53.1638 394.072",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 533.044C1133.16 533.044 775.071 23.9613 626.529 160.787C560.21 221.876 606.654 313.126 542.09 376.083C394.145 520.347 237.574 17.2092 70.1508 138.124C-21.5535 204.356 -53.1638 400.844 -53.1638 400.844",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 539.816C1133.16 539.816 775.071 30.7335 626.529 167.559C560.21 228.648 606.654 319.898 542.09 382.856C394.145 527.119 237.574 23.9815 70.1508 144.897C-21.5535 211.128 -53.1638 407.617 -53.1638 407.617",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 546.587C1133.16 546.587 775.071 37.5048 626.529 174.33C560.21 235.419 606.654 326.67 542.09 389.626C394.145 533.891 237.574 30.7528 70.1508 151.667C-21.5535 217.899 -53.1638 414.387 -53.1638 414.387",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 553.359C1133.16 553.359 775.071 44.2765 626.529 181.102C560.21 242.19 606.654 333.442 542.09 396.398C394.145 540.662 237.574 37.5244 70.1508 158.439C-21.5535 224.671 -53.1638 421.159 -53.1638 421.159",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 560.131C1133.16 560.131 775.071 51.0488 626.529 187.874C560.21 248.963 606.654 340.214 542.09 403.17C394.145 547.434 237.574 44.2968 70.1508 165.211C-21.5535 231.444 -53.1638 427.932 -53.1638 427.932",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 566.903C1133.16 566.903 775.071 57.8212 626.529 194.646C560.21 255.735 606.654 346.986 542.09 409.943C394.145 554.206 237.574 51.0688 70.1508 171.984C-21.5535 238.215 -53.1638 434.704 -53.1638 434.704",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 573.674C1133.16 573.674 775.071 64.5912 626.529 201.417C560.21 262.506 606.654 353.756 542.09 416.714C394.145 560.977 237.574 57.8394 70.1508 178.754C-21.5535 244.986 -53.1638 441.475 -53.1638 441.475",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 580.446C1133.16 580.446 775.071 71.3642 626.529 208.189C560.21 269.278 606.654 360.529 542.09 423.486C394.145 567.75 237.574 64.6124 70.1508 185.527C-21.5535 251.759 -53.1638 448.247 -53.1638 448.247",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 587.218C1133.16 587.218 775.071 78.136 626.529 214.961C560.21 276.05 606.654 367.301 542.09 430.257C394.145 574.522 237.574 71.3841 70.1508 192.298C-21.5535 258.531 -53.1638 455.019 -53.1638 455.019",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 593.991C1133.16 593.991 775.071 84.9085 626.529 221.734C560.21 282.822 606.654 374.074 542.09 437.03C394.145 581.294 237.574 78.1567 70.1508 199.071C-21.5535 265.303 -53.1638 461.791 -53.1638 461.791",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 600.761C1133.16 600.761 775.071 91.6794 626.529 228.505C560.21 289.593 606.654 380.845 542.09 443.801C394.145 588.064 237.574 84.9268 70.1508 205.842C-21.5535 272.073 -53.1638 468.562 -53.1638 468.562",
    stroke: "#F07900",
    strokeWidth: 0.836031
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinePatterns);
export default __webpack_public_path__ + "static/media/linePatterns.f898f212055e18c8bb5ad7a486522bee.svg";
export { ForwardRef as ReactComponent };